"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.toFirstLetterLowerCase = void 0;
/**
 * Give this `TextInput` or `textInput` and it returns `textInput`.
 */
function toFirstLetterLowerCase(str) {
    if (!str) {
        return '';
    }
    return (str.charAt(0).toLowerCase() + str.slice(1));
}
exports.toFirstLetterLowerCase = toFirstLetterLowerCase;
